// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:24
import { MobActor_abstract } from './../abstract/SagaSchema/MobActor_abstract';
export class MobActor extends MobActor_abstract {}
